class AddToCart {
  static async addToCart(formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Network response was not ok');
      
      const item = await response.json();
      
      // Disparar evento de producto añadido
      window.dispatchEvent(new CustomEvent('product:added', {
        detail: { item }
      }));
      
      // Abrir el drawer del carrito
      const cartButton = document.querySelector('[data-drawer-toggle="cart"]');
      if (cartButton) cartButton.click();
      
      return { success: true, item };
    } catch (error) {
      console.error('Error:', error);
      return { success: false, error };
    }
  }

  static async handleSubmit(event, button) {
    event.preventDefault();
    
    const originalText = button.innerHTML;
    button.innerHTML = '<span class="loading-spinner"></span> Adding...';
    button.disabled = true;

    let formData;
    if (event.target.tagName === 'FORM') {
      formData = new FormData(event.target);
    } else {
      formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', 1);
    }

    const result = await this.addToCart(formData);

    if (result.success) {
      button.innerHTML = '<span>Added</span>';
    } else {
      button.innerHTML = 'Error - Try Again';
    }

    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 2000);
  }
}

window.AddToCart = AddToCart;
